<template>
  <div class="websitePage">
    <!-- 提交确定框-->
    <el-dialog title="提示"
               :visible.sync="marketing_dialog"
               width="30%">
      <span v-if="siteid">确定修改营销网址吗？</span>
      <span v-else>确定要建立营销网址吗?您只能建立<span style="color:red">一个</span>营销网站</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="marketing_dialog = false">取 消</el-button>
        <el-button type="primary"
                   @click="submit_wabsite_data()">确 定</el-button>
      </span>
    </el-dialog>

    <div class="websitePage_top">
      <div class="websitePage_title">
        <span>
          基本参数
        </span>
      </div>
      <div class="websitePage_main">
        <el-form :model="websiteData"
                 label-position='top'
                 ref="websiteData"
                 label-width="100px"
                 class="demo-ruleForm">
          <el-form-item label="公司名称"
                        prop="companyName"
                        :rules="[
      { required: true, message: '公司名称必须填写'},
      { min:3,max:30, message: '公司名3-30个字，请简称'}
    ]">
            <el-input placeholder="请输入公司名称，如：团运国际物流"
                      v-model="websiteData.companyName"
                      autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item label="公司地址"
                        prop="companySite"
                        :rules="[
      { required: true, message: '公司地址必须填写'},
      { min:10,max:40, message: '公司名10-30个字'}
    ]">
            <el-input placeholder="请输入公司地址，如：东莞南城街道白马社区黄金一路5号 国宁科技园二期113-116"
                      v-model="websiteData.companySite"
                      autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item label="联系电话"
                        prop="contactNumber"
                        :rules="[
      { required: true, message: '公司联系电话必须填写'},
    ]">
            <el-input placeholder="请输入公司联系电话，如：0769-22629599"
                      v-model="websiteData.contactNumber"
                      autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item v-if="!type"
                        label="网址域名"
                        prop="realmName"
                        :rules="siteid?[]: [
      { required: true, message: '公司域名必须填写'},
    ]">
            <el-input placeholder="请输入自己要配置的域名，如：https://www.tuanyun99.com（更改后需尽快更新）"
                      v-model="websiteData.realmName"
                      autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item v-if="!type"
                        label="备案号填写"
                        prop="records"
                        :rules="[
      { required: true, message: '无备案号的网页将被相关机构禁止访问'},
    ]">
            <el-input placeholder="请输入自己公司域名备案号，如：粤ICP备2020076811号（仅供参考）"
                      v-model="websiteData.records"
                      autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item label="系统地址-电脑端:"
                        prop="pcSite"
                        :rules="[
      { required: true, message: '下单系统地址为空用户将无法下单'},
    ]">
            <el-input placeholder="请输入您下单系统的域名地址"
                      v-model="websiteData.pcSite"
                      autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item label="系统地址-手机端:"
                        prop="peSite"
                        :rules="[
      { required: true, message: '下单系统地址为空用户将无法下单'},
    ]">
            <el-input placeholder="请输入您下单系统的域名地址"
                      v-model="websiteData.peSite"
                      autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item class="seoOptimize"
                        label="网页搜索引擎SEO优化"
                        prop="publicitySpeech">
            <div class="seoOptimize_view">
              <el-tag :key="index"
                      v-for="(tag,index) in websiteData.seoData"
                      closable
                      :disable-transitions="false"
                      @close="handleClose(tag)">
                {{tag}}
              </el-tag>
              <el-input class="input-new-tag"
                        v-if="inputVisible"
                        v-model="inputValue"
                        ref="saveTagInput"
                        size="small"
                        @keyup.enter.native="handleInputConfirm"
                        @blur="handleInputConfirm">
              </el-input>
              <el-button v-else
                         class="button-new-tag"
                         size="small"
                         @click="showInput">+ 搜索词</el-button>
            </div>
          </el-form-item>

          <el-form-item label="基本Logo"
                        class="logoView"
                        style="width:25%"
                        prop="companyLogo"
                        ref="file_Rule"
                        :rules="[
      { required: true, message: '公司LOGO必须上传'},
    ]">
            <el-upload class="avatar-uploader"
                       :action='upUrl'
                       :data='{name:"12001"}'
                       :show-file-list="false"
                       :on-success="(res)=>{logoUploadSuccess(res,1)}"
                       :before-upload="beforeAvatarUpload">
              <img v-if="logoImageUrl"
                   :src="logoImageUrl"
                   class="avatar">
              <i v-else
                 class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="上下型Logo"
                        class="logoView"
                        style="width:25%"
                        prop="companyLogo"
                        ref="file_Rule"
                        :rules="[
      { required: true, message: '公司LOGO必须上传'},
    ]">
            <el-upload class="avatar-uploader"
                       :action='upUrl'
                       :data='{name:"12002"}'
                       :show-file-list="false"
                       :on-success="(res)=>{logoUploadSuccess(res,2)}"
                       :before-upload="beforeAvatarUpload">
              <img v-if="logoImageUrl_2"
                   :src="logoImageUrl_2"
                   class="avatar">
              <i v-else
                 class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="褪色Logo"
                        class="logoView"
                        style="width:25%"
                        prop="companyLogo"
                        ref="file_Rule"
                        :rules="[
      { required: true, message: '公司LOGO必须上传'},
    ]">
            <el-upload class="avatar-uploader"
                       :data='{name:"12003"}'
                       :action='upUrl'
                       :show-file-list="false"
                       :on-success="(res)=>{logoUploadSuccess(res,3)}"
                       :before-upload="beforeAvatarUpload">
              <img v-if="logoImageUrl_3"
                   :src="logoImageUrl_3"
                   class="avatar">
              <i v-else
                 class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="图案LOGO"
                        class="logoView"
                        style="width:25%"
                        prop="companyLogo"
                        ref="file_Rule"
                        :rules="[
      { required: true, message: '公司LOGO必须上传'},
    ]">
            <el-upload class="avatar-uploader"
                       :data='{name:"12021"}'
                       :action='upUrl'
                       :show-file-list="false"
                       :on-success="(res)=>{logoUploadSuccess(res,4)}"
                       :before-upload="beforeAvatarUpload">
              <img v-if="logoImageUrl_4"
                   :src="logoImageUrl_4"
                   class="avatar">
              <i v-else
                 class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="微信二维码1"
                        style="width:40%"
                        class="logoView"
                        :data='{name:"12004"}'
                        ref="file_Rule_2"
                        prop="weChat_code"
                        :rules="[
      { required: true, message: '公司微信二维码必须上传'},
    ]">
            <el-upload class="avatar-uploader"
                       :action='upUrl'
                       :show-file-list="false"
                       :on-success="(res)=>{wechatCodeUploadSuccess(res,1)}"
                       :before-upload="beforeAvatarUpload">
              <img v-if="wechatImageUrl"
                   :src="wechatImageUrl"
                   class="avatar">
              <i v-else
                 class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="微信二维码2"
                        style="width:40%"
                        :data='{name:"12005"}'
                        class="logoView"
                        ref="file_Rule_2"
                        prop="weChat_code"
                        :rules="[
      { required: true, message: '公司微信二维码必须上传'},
    ]">
            <el-upload class="avatar-uploader"
                       :action='upUrl'
                       :show-file-list="false"
                       :on-success="(res)=>{wechatCodeUploadSuccess(res,2)}"
                       :before-upload="beforeAvatarUpload">
              <img v-if="wechatImageUrl_2"
                   :src="wechatImageUrl_2"
                   class="avatar">
              <i v-else
                 class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>

          <el-form-item class="submit_btn">
            <el-button type="primary"
                       @click="tab_domainName()">切换模式</el-button>
            <el-button type="primary"
                       @click="detection_data('websiteData')">提交</el-button>
            <!-- <el-button @click="resetForm('numberValidateForm')">重置</el-button> -->
          </el-form-item>
        </el-form>
      </div>

    </div>
    <div class="websitePage_browse">
      <div class="browse_title">
        <span>logo示范</span>
      </div>
      <div class="browse_view">
        <el-form label-position='top'
                 label-width="100px">
          <el-form-item label="基本logo示范"
                        prop="companyName">
            <el-image style="min-width: 100px; height: 100px"
                      :src="require('../../assets/images/logo_1.png')"></el-image>
          </el-form-item>
          <el-form-item label="上下logo示范">
            <el-image style="min-width: 100px; height: 100px"
                      :src="require('../../assets/images/logo_3.png')"></el-image>
          </el-form-item>

          <el-form-item label="褪色logo示范">
            <el-image style="min-width: 100px; height: 100px"
                      :src="require('../../assets/images/hb_logo.png')"></el-image>
          </el-form-item>

        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store/index'
import { apiSubmitMarketing, apiDelete, apiGetMarketing } from '@/request/api'
export default {
  name: 'websitePage',
  data () {
    return {
      bindhost: '',
      //--------------网络请求url -----------
      upUrl: '',
      //--------------seo优化词 -----------
      // seoData:[]
      //--------------上次记录的logo id -----------
      logoID: false,
      //--------------上次记录的二维码 id -----------
      weChatID: false,
      //--------------上传成功浏览wechat图 -----------
      wechatImageUrl: false,
      //--------------上传成功浏览wechat图 -----------
      wechatImageUrl_2: false,
      //--------------上传成功浏览logo图 -----------
      logoImageUrl: false,
      //--------------上传成功浏览logo图 -----------
      logoImageUrl_2: false,
      //--------------上传成功浏览logo图 -----------
      logoImageUrl_3: false,
      //--------------上传成功浏览logo图 -----------
      logoImageUrl_4: false,
      //--------------超级管理员传此项目  -----------
      uid: '',
      //--------------如果修改网址则会有id -----------
      siteid: '',
      //--------------建立营销网址提示对话框-----------
      marketing_dialog: false,
      //--------------添加的seo数据-----------
      inputValue: '',
      //--------------是否可以继续添加数据-----------
      inputVisible: false,
      //--------------网站基本参数-----------
      websiteData: {
        companyName: '',                     //公司名 
        companyLogo: '',                     //公司logo
        companyLogo_2: '',                     //公司logo
        companyLogo_3: '',                     //公司logo
        companySite: '',                      //公司地址
        publicitySpeech: '',                 //网站宣传语
        contactNumber: '',                 //联系电话
        weChat_code: '',                 //微信二维码
        seoData: [],                          //SEO优化

        records: '',                        //备案号
        realmName: '',                        //域名
        weChat_code_2: '',
        pcSite: '',
        peSite: '',
      },
      //--------------建立网址类型-----------
      type: ''
    }
  },
  methods: {
    //--------------切换域名模式-----------
    tab_domainName () {
      this.type = !this.type
    },
    //--------------上传检测-----------
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG或png 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    //--------------wxCode上传成功回调-----------
    async wechatCodeUploadSuccess (res, type) {
      if (res.error) {
        return this.$message.error(res.error.message)
      }
      switch (type) {
        case 1:
          this.wechatImageUrl = res.url
          this.websiteData.weChat_code = res.url
          break;
        case 2:
          this.wechatImageUrl_2 = res.url
          this.websiteData.weChat_code_2 = res.url
          break;
        default:
          break;
      }
      this.$refs.file_Rule_2.clearValidate();  //取消检测
    },
    //--------------logo上传成功回调-----------
    async logoUploadSuccess (res, type) {
      if (res.error) {
        return this.$message.error(res.error.message)
      }
      switch (type) {
        case 1:
          this.logoImageUrl = res.url
          this.websiteData.companyLogo = res.url
          break;
        case 2:
          this.logoImageUrl_2 = res.url
          this.websiteData.companyLogo_2 = res.url

          break;
        case 3:
          this.logoImageUrl_3 = res.url
          this.websiteData.companyLogo_3 = res.url
          break;
        case 4:
          this.logoImageUrl_4 = res.url
          this.websiteData.companyLogo_4 = res.url
          break
        default:
          break;
      }
      this.$refs.file_Rule.clearValidate();  //取消检测
    },
    //--------------提交营销网站数据-----------
    async submit_wabsite_data () {
      let res = await apiSubmitMarketing({
        mode: this.type ? 1 : 2,
        siteid: this.siteid,
        uid: this.uid,
        title: this.websiteData.companyName,
        styleid: 1,
        site_info: this.websiteData,
        status: 1,
        bindhost: this.websiteData.realmName
      })
      if (res.errno == 1) {
        this.$message.error(res.message)
      } else {
        this.$message.success(res.message)
        localStorage.setItem('websitePage_logoID', '')
        localStorage.setItem('websitePage_weChatID', '')
        if (this.siteid) {
          this.$router.go(-1)
        } else {
          this.$router.go(-1)
        }
      }
      this.marketing_dialog = false
    },
    //--------------检测数据是否正常-----------
    detection_data (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.marketing_dialog = true
        } else {
          return false;
        }
      });
    },
    //--------------显示seo输入框并且获取焦点-----------
    showInput () {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    //--------------确定seo标签数据-----------
    handleInputConfirm () {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.websiteData.seoData.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    //--------------删除seo标签-----------
    handleClose (tag) {
      this.websiteData.seoData.splice(this.websiteData.seoData.indexOf(tag), 1);
    },
  },
  async created () {
    this.siteid = this.$route.query.siteid

    this.upUrl = store.state.upUrl;
    let type_s = this.$route.query.type_s
    if (type_s) {
      let res = await apiGetMarketing({
        siteid: this.siteid
      })
      if (res.errno == 0) {
        let siteWebInfo = res.sitelist[0]
        this.siteid = siteWebInfo.id
        this.wechatImageUrl = siteWebInfo.site_info.weChat_code
        this.logoImageUrl = siteWebInfo.site_info.companyLogo
        this.logoImageUrl_2 = siteWebInfo.site_info.companyLogo_2
        this.logoImageUrl_3 = siteWebInfo.site_info.companyLogo_3
        this.logoImageUrl_4 = siteWebInfo.site_info.companyLogo_4
        this.wechatImageUrl_2 = siteWebInfo.site_info.weChat_code_2
        this.websiteData = {
          companyName: siteWebInfo.site_info.companyName || '',                     //公司名 
          companyLogo: siteWebInfo.site_info.companyLogo || '',                     //公司logo
          companyLogo_2: siteWebInfo.site_info.companyLogo_2 || '',                     //公司logo
          companyLogo_3: siteWebInfo.site_info.companyLogo_3 || '',                     //公司logo
          companySite: siteWebInfo.site_info.companySite || '',                      //公司地址
          publicitySpeech: siteWebInfo.site_info.publicitySpeech || '',                 //网站宣传语
          contactNumber: siteWebInfo.site_info.contactNumber || '',                 //联系电话
          weChat_code: siteWebInfo.site_info.weChat_code || '',                 //微信二维码
          weChat_code_2: siteWebInfo.site_info.weChat_code_2 || '',                 //微信二维码
          seoData: siteWebInfo.site_info.seoData || [],                          //SEO优化
          records: siteWebInfo.site_info.records || '',                        //备案号
          pcSite: siteWebInfo.site_info.pcSite || '',                        //域名
          peSite: siteWebInfo.site_info.peSite || '',
          realmName: siteWebInfo.bindhost                   //域名
          // weChat_code: siteWebInfo.site_info.weChat_code || ''
        }
      }
    }
    this.type = this.$route.query.type
    // this.siteid = this.$route.query.siteid
    this.uid = this.$route.query.puid
    this.weChatID = localStorage.getItem('websitePage_weChatID')
    this.logoID = localStorage.getItem('websitePage_logoID')
  }
}
</script>

<style lang="scss">
.avatar-uploader .el-upload {
  width: 200px;
  height: 200px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader .el-upload:hover .avatar-uploader-icon {
  color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.avatar {
  width: 100%;
  height: 100%;
}
.websitePage {
  width: 100%;
  height: 100%;
  // background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  // justify-content: space-between;
  .websitePage_browse {
    width: 100%;
    height: 350px;
    border-radius: 4px;
    margin-top: 10px;
    background-color: #ffffff;
    .browse_title {
      font-size: 20px;
      display: flex;
      justify-content: center;
      margin-top: 5px;
      letter-spacing: 2px;
      span {
        box-shadow: -3px 13px 0px -10px #28292f75;
      }
    }
    .browse_view {
      padding: 0 20px;
      .el-form {
        display: flex;
        .el-form-item {
          margin-right: 50px;
        }
      }
    }
  }

  .websitePage_top {
    width: 100%;
    // height: 500px;
    border-radius: 4px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    .websitePage_title {
      font-size: 20px;
      display: flex;
      justify-content: center;
      margin-top: 5px;
      letter-spacing: 2px;
      span {
        box-shadow: -3px 13px 0px -10px #28292f75;
      }
    }
  }
  .websitePage_main {
    margin-top: 10px;
    // height: 500px;
    background-color: #fff;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 20px;
    .el-form {
      display: flex;
      flex-wrap: wrap;
      .logoView {
        // width: 20% !important;
        img {
          height: auto !important;
        }
      }
      .submit_btn {
        width: 100% !important;
        display: flex;
        justify-content: flex-end;
      }
      .seoOptimize {
        width: 100% !important;
        .seoOptimize_view {
          width: 100%;
          min-height: 40px;
          // background-color: pink;
          .el-tag + .el-tag {
            margin-left: 10px;
            // width: 90px;
          }
          .button-new-tag {
            margin-left: 10px;
            height: 32px;
            width: 90px;
            line-height: 30px;
            padding-top: 0;
            padding-bottom: 0;
          }
          .input-new-tag {
            width: 90px;
            margin-left: 10px;
            vertical-align: bottom;
          }
        }
      }
      .el-form-item {
        width: 33%;
        padding: 10px;
        box-sizing: border-box;
      }
    }
  }
}
</style>